<div class="zwi-caption" [class]="{'zwi-text-center': center, 'zwi-body--offset': offset}">
  <ng-content></ng-content>
</div>
